import { useEffect, useRef } from "react";
import { Animated, Easing } from "react-native";

const CHEVRON_ROTATION_OUTPUT_RANGES = {
  closedUpOpenDown: ["-180deg", "0deg"],
  closedDownOpenUp: ["0deg", "-180deg"],
};

export default function useChevronRotation(
  isOpen,
  variant = "closedUpOpenDown",
) {
  const spinValue = useRef(new Animated.Value(isOpen ? 1 : 0)).current;
  const outputRange =
    CHEVRON_ROTATION_OUTPUT_RANGES[variant] ??
    CHEVRON_ROTATION_OUTPUT_RANGES.closedUpOpenDown;

  useEffect(() => {
    Animated.timing(spinValue, {
      toValue: isOpen ? 1 : 0,
      duration: 280,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: true,
    }).start();
  }, [isOpen, spinValue]);

  return spinValue.interpolate({
    inputRange: [0, 1],
    outputRange,
  });
}
